import React from 'react';
import { useQueries } from '@magoosh/gre/app/queries';
import TopicSlice from '../../../../organisms/topic_slice';
import StatusMessage from '../../../../lib/status_message';
import { TopicSliceProps } from '../../../../organisms/topic_slice/types';

export const VerbalContent: React.FC = () => {
  const query = useQueries().topicsQuery('verbal');

  if (query.isLoading) {
    return (
      <StatusMessage
        headline="One Second!"
        isColored
        text="We are looking for verbal topics"
      />
    );
  } else {
    return (
      <>
        <h3>All Verbal Topics</h3>
        {query.data.map((topic) => (
          <TopicSlice
            key={topic.id}
            icon={`${topic.significanceLevel}Significance` as TopicSliceProps['icon']}
            {...topic}
            subsection="verbal"
          />
        ))}
      </>
    );
  }
};

export default VerbalContent;
